import React from 'react';
import { Alert, Box, SpaceBetween, Button } from '@amzn/awsui-components-console';
import { CONTACT_US } from '../lib/constants';

/**
 * Component to display when user doesn't have lab admin permissions
 */
export default function LabPermissionDenied() {
    return (
        <Box padding={{ top: 'xxxl', horizontal: 'xl' }}>
            <SpaceBetween size="l">
                <Alert type="error" header="Access restricted - Lab administrator permission required">
                    <SpaceBetween size="m">
                        <Box>You don't have the necessary lab administrator permissions to access this resource.</Box>
                        <Box>This page is restricted to authorized lab administrators only.</Box>
                        <Box>
                            <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
                                <li>Reach out to DS2 Device Farm support for assistance</li>
                            </ul>
                        </Box>
                        <Box>
                            <Button href={CONTACT_US} iconAlign="right" target="_blank" variant="primary">
                                Contact support
                            </Button>
                        </Box>
                    </SpaceBetween>
                </Alert>
            </SpaceBetween>
        </Box>
    );
}
